cockpitApp.provider('checkout', [
  function () {
    this.setApiCheckoutAdyenSessionEndpoint = function (endpoint) {
      this.apiCheckoutAdyenSessionEndpoint = endpoint;
    };

    this.setApiCheckoutAdyenOrderEndpoint = function (endpoint) {
      this.apiCheckoutAdyenOrderEndpoint = endpoint;
    };
    
    this.$get = ['cockpitClient',
      function (cockpitClient) {
        var self = this;

        return {
          getSession: getAdyenSession,
          adyenOrder: adyenOrder
        };

        function getAdyenSession(requestParams) {
          var response = cockpitClient.remoteCall(self.apiCheckoutAdyenSessionEndpoint, requestParams, 'POST', null, null);

          return cockpitClient.resolveRequest(response);
        }

        function adyenOrder(requestParams) {
          var response = cockpitClient.remoteCall(self.apiCheckoutAdyenOrderEndpoint, requestParams, 'POST', null, null);

          return cockpitClient.resolveRequest(response);
        }
      }
    ];
  }
]);
